import type {IterationValue} from '../../../../../api/columns/contracts/iteration'
import {MemexColumnDataType} from '../../../../../api/columns/contracts/memex-column'
import {getAllIterations} from '../../../../../helpers/iterations'
import {sanitizeTextInputHtmlString} from '../../../../../helpers/sanitize'
import type {IterationColumnModel} from '../../../../../models/column-model/custom/iteration'
import type {TableDataType} from '../../../table-data-type'

export const readIterationCellClipboardContent = (row: TableDataType, column: IterationColumnModel) => {
  const customColumnValue = row.columns[column.id]
  const customValue = customColumnValue as IterationValue
  const valueId = customValue?.id

  const allIterations = getAllIterations(column)
  const matchingIteration = allIterations.find(i => i.id === valueId)
  const raw = customValue
  const text = matchingIteration?.title || ''

  return {
    text,
    dataType: MemexColumnDataType.Iteration,
    value: raw,
    html: matchingIteration ? sanitizeTextInputHtmlString(matchingIteration.titleHtml) : '',
  }
}
